import type { LinkItem } from '../types/content';

export const SYNEURAL_URL = 'https://syneural.com';
export const SYNEURAL_SKP_URL = 'https://syneural.com/semantic-knowledge-platform';
export const SYNEURAL_HCF_URL = 'https://syneural.com/human-capability-framework';
export const DEMO_CENTER_URL = 'https://noetivra-workspace.abledream3.chatgpt.site/#demos';

export const primaryNav: LinkItem[] = [
  { label: 'Workspaces', to: '/workspaces' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Demos', to: '/demos' },
  { label: 'About', to: '/about' },
];

export const footerGroups: { title: string; links: LinkItem[] }[] = [
  {
    title: 'Workspaces',
    links: [
      { label: 'Research', to: '/workspaces/research' },
      { label: 'Government', to: '/workspaces/government' },
      { label: 'Education', to: '/workspaces/education' },
      { label: 'Talent & Workforce', to: '/workspaces/talent' },
      { label: 'Clinical', to: '/workspaces/clinical' },
      { label: 'Community', to: '/workspaces/community' },
      { label: 'Leadership', to: '/workspaces/leadership' },
    ],
  },
  {
    title: 'Product',
    links: [
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Modules', to: '/how-it-works#modules' },
      { label: 'Demos', to: '/demos' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Noetivra', to: '/about' },
      { label: 'SyNeural', href: SYNEURAL_URL },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
];
